import { render, staticRenderFns } from "./DHWSPlayer.vue?vue&type=template&id=3115150a&scoped=true"
import script from "./DHWSPlayer.vue?vue&type=script&lang=js"
export * from "./DHWSPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3115150a",
  null
  
)

export default component.exports